import React, { useEffect, useState } from 'react';
import AdminDashboard from 'layouts/AdminDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getApp } from './AppService';
import { useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import { format } from 'date-fns';
import { toDate } from 'date-fns-tz';

// import ItemList from './ItemList';
import SelectedItemList from './SelectedItemList';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const AppDetail = (): JSX.Element => {
  const [appName, setAppName] = useState('');
  const [appDescription, setAppDescription] = useState('');
  const [versionNumber, setVersionNumber] = useState('');
  const [buildNumber, setBuildNumber] = useState('');
  const [appCode, setAppCode] = useState('');
  const [status, setStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { appid } = useParams();
  const { subscriptionid } = useParams();

  //const [parentLevel, setLevel] = useState(0);

  useEffect(() => {
    if (appid) {
      console.log('Itemid exists: ', appid);
      getApp(subscriptionid, appid)
        .then((response) => {
          console.log(response.data);
          setAppName(response.data.appName);
          setAppDescription(response.data.appDescription);
          setVersionNumber(response.data.versionNumber);
          setBuildNumber(response.data.buildNumber);
          setAppCode(response.data.appCode);
          setStatus(response.data.status);
          setStartDate(response.data.startDate);
          setEndDate(response.data.endDate);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [subscriptionid, appid]);

  const timeZone = 'Europe/London';
  const formatString = 'dd-MM-yyyy HH:mm:ss';

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const zonedDate = toDate(date, { timeZone });
    return format(zonedDate, formatString);
  };

  return (
    <Container>
      <AdminDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Your Apps
            </Link>
            <Link
              underline="hover"
              color="inherit"
              //href={`/dashboard/dashboard/items/section/${sectionId}`}
            >
              Apps
            </Link>
            <Typography color="text.primary">App Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Box sx={{ width: '65%' }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginBottom={4}
            >
              <Typography variant="h4">App Detail</Typography>
            </Box>

            <Box>
              <form>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      App Name
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'appName'}
                      fullWidth
                      value={appName}
                      onChange={(event) => setAppName(event.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Section ID
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'sectionId'}
                      fullWidth
                      value={sectionId}
                      onChange={(event) => setSectionId(event.target.value)}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      App Description
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'appDescription'}
                      fullWidth
                      value={appDescription}
                      onChange={(event) =>
                        setAppDescription(event.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Version Number
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'versionNumber'}
                      fullWidth
                      value={versionNumber}
                      onChange={(event) => setVersionNumber(event.target.value)}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Level
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'parentLevel'}
                      fullWidth
                      value={parentLevel}
                      onChange={(event) => setLevel(Number(event.target.value))}
                      type="number" // Ensures the input is numerical
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Build Number
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'buildNumber'}
                      fullWidth
                      value={buildNumber}
                      onChange={(event) => setBuildNumber(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      App Code
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'appCode'}
                      fullWidth
                      value={appCode}
                      onChange={(event) => setAppCode(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Status
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'status'}
                      fullWidth
                      value={status}
                      onChange={(event) => setStatus(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      Start Date
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'startDate'}
                      fullWidth
                      value={formatDate(startDate)}
                      onChange={(event) => setStartDate(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant={'subtitle2'}
                      sx={{ marginBottom: 2 }}
                      fontWeight={700}
                    >
                      End Date
                    </Typography>
                    <TextField
                      variant="outlined"
                      name={'endDate'}
                      fullWidth
                      value={formatDate(endDate)}
                      onChange={(event) => setEndDate(event.target.value)}
                    />
                  </Grid>
                  <Grid item container xs={12}>
                    <Box
                      display="flex"
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      alignItems={{ xs: 'stretched', sm: 'center' }}
                      justifyContent={'space-between'}
                      width={1}
                      marginBottom={4}
                    ></Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Box>
          {/* <Box sx={{ width: '30%', marginLeft: '30px' }}>
            <ItemAssignmentList />
          </Box> */}
        </Box>
        <Box>
          Selected Item List
          <SelectedItemList appId={appid} subscriptionId={subscriptionid} />
        </Box>
      </AdminDashboard>
    </Container>
  );
};

export default AppDetail;
